import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useField, useFormikContext} from 'formik';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {CompanySettings} from '../../../../types/Company/CompanySettings';

export default function BccEmailsAutoComplete() {
  const { values, setFieldValue } = useFormikContext<CompanySettings.Account>();

  const [, { touched, error }] = useField('bccEmailAddressList');

  const { t } = useTranslation('company');

  function _renderHelperText() {
    if (touched && error) {
      return error;
    }
  }

  return (
    <Autocomplete
      freeSolo
      multiple
      options={[]}
      id="bccEmailAddressList"
      onChange={(event, values) => setFieldValue('bccEmailAddressList', values)}
      value={values.bccEmailAddressList}
      renderTags={(value: string[], getTagProps: any) =>
        value.map((option: string, index: number) => <Chip variant="outlined" label={option} {...getTagProps({ index })} />)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          // Autocomplete controls value; avoid passing value to TextField to prevent controlled/uncontrolled conflict
          variant="standard"
          error={touched && !!error && true}
          helperText={_renderHelperText()}
          InputLabelProps={{
            shrink: true,
          }}
          label={t('label bccEmailAddressList')}
        />
      )}
    />
  );
}
